import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import UserContext from '../../context/user/UserContext';
import { useSystemInformationService } from '../../hooks/services/useSystemInformationService';
import { useToastrVanila } from '../../hooks/util/useToastrVanila';
import useWindowDimensions from '../../hooks/util/useWindowDimensions';

interface IFooterStyledProps {
  logged?: boolean;
}

const FooterStyled = styled.div`
  visibility: ${(props: IFooterStyledProps) => (props.logged ? 'visible' : 'hidden')};
  height: ${(props: IFooterStyledProps) => (props.logged ? '30px' : '0px')};
  opacity: ${(props: IFooterStyledProps) => (props.logged ? '1' : '1')};
  padding: ${(props: IFooterStyledProps) => (props.logged ? '10px' : '0px')};
  transition: visibility 0.5s, opacity 0.5s linear;
  width: 100%;
  font-weight: 400;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 10px;
  background-color: #454545;
  color: #fff;
`;

const Span = styled.span`
  margin-right: 20px;
`;

const Img = styled.img`
  width: 10px;
  height: 20px;
  margin-right: 10px;
`;

const Footer = () => {
  const systemInfo = useSystemInformationService();
  const toastr = useToastrVanila();
  const { state: userState } = useContext(UserContext);
  const [version, setVersion] = useState<string | null>(null);

  const { width } = useWindowDimensions();

  const getSystemInfo = async () => {
    await systemInfo
      .getSystemInformation()
      .then(res => {
        setVersion(res.currentVersion);
      })
      .catch(error => {
        toastr.error(error.message);
      });
  };
  useEffect(() => {
    if (userState.logged) {
      getSystemInfo();
    }
  }, [userState.logged]);
  return (
    <FooterStyled logged={userState.logged}>
      {userState.logged && (
        <>
          {width > 500 ? (
            <>
              <Img src={require('../../assets/logo.png')} alt="Senior" />
              <Span>Desenvolvido por Senior Norte PR</Span>
              {version && (
                <>
                  <Span>|</Span>
                  <Span>Versão: {version}</Span>
                </>
              )}
            </>
          ) : (
            <>
              <Img src={require('../../assets/logo.png')} alt="Senior" />
              <Span>SeniorNortePR</Span>
            </>
          )}
        </>
      )}
    </FooterStyled>
  );
};

export default Footer;
